import { trackEventImpression } from 'api/services/events/event-impressions';
import { ErrorResponse } from 'api/types/errors';
import { useMutation } from 'react-query';

export function useTrackEventImpressionMutation() {
  return useMutation<void, ErrorResponse, string>((eventId) =>
    trackEventImpression(eventId)
  );
}
